import { Exclude } from 'class-transformer';

export class ConveyanceClosingFeeRuleResultDto {
    ruleCodeId: number;
    ruleCode: string;
    initialAssessment: number;
    workingCapital: number;
    conveyanceProcessingFee: number;
    ruleDescription: string;
    buyerRateType: string;
    sellerRateType: string;

    // Transient variable
    @Exclude()
    isSelected = false;
}
